import { useAmplitudeIdentity as useAmplitudeUserIdentity } from '@repo/amplitude/client';
import { useRouteContext } from '@tanstack/react-router';

import { AMPLITUDE_ENVIRONMENT } from '~/config/env';

// Lives at the root, next to useMonitoringIdentity, so it also sees the logout.
const useAmplitudeIdentity = () => {
  const { user } = useRouteContext({ from: '__root__' });

  // Same traits Segment's identify sends.
  useAmplitudeUserIdentity(
    AMPLITUDE_ENVIRONMENT,
    user
      ? {
          id: user.id,
          email: user.email,
          username: `${user.first_name} ${user.last_name}`,
          role: user.role,
        }
      : undefined,
  );
};

export default useAmplitudeIdentity;
